import React from 'react';
import { Link } from 'react-router-dom';
import { CalendarCheck, ClipboardList, PartyPopper, ArrowRight } from 'lucide-react';
import Reveal from '../ui/Reveal';

const STEPS = [
  {
    icon: ClipboardList,
    title: 'Tell us about your pet',
    text: "First visit? Our intake form covers health, temperament and styling so we're ready for them.",
    cta: { label: 'New client form', to: '/intake-form' },
    gradient: 'from-pink-500 to-rose-400',
    rotate: '-rotate-2',
  },
  {
    icon: CalendarCheck,
    title: 'Book online',
    text: 'Pick your service and a time that suits you — it takes under two minutes.',
    cta: { label: 'Book now', to: '/booking' },
    gradient: 'from-purple-500 to-fuchsia-400',
    rotate: 'rotate-1',
  },
  {
    icon: PartyPopper,
    title: 'Spa day!',
    text: 'Drop off a scruffy friend, pick up a superstar — bandanna, photos and tail wags included.',
    cta: { label: 'See services', to: '/#services' },
    gradient: 'from-cyan-500 to-blue-400',
    rotate: '-rotate-1',
  },
];

export default function HowItWorks() {
  return (
    <section className="relative py-20 md:py-28 bg-gradient-to-b from-pink-50/80 via-white to-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4">
        <Reveal className="text-center max-w-2xl mx-auto">
          <p className="text-xs md:text-sm font-extrabold uppercase tracking-[0.22em] text-pink-500">How it works</p>
          <h2 className="mt-3 font-display text-4xl sm:text-5xl md:text-6xl font-black text-ink-900 leading-[1.02] tracking-tight">
            Three steps to a
            <span className="bg-gradient-to-r from-pink-500 to-cyan-500 bg-clip-text text-transparent"> very good day.</span>
          </h2>
        </Reveal>

        <div className="mt-14 md:mt-20 grid md:grid-cols-3 gap-8 md:gap-6 lg:gap-10">
          {STEPS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.14}>
              <div className={`relative bg-white rounded-[2rem] p-8 shadow-xl shadow-pink-100/60 border border-pink-100/60 h-full flex flex-col ${s.rotate} hover:rotate-0 transition-transform duration-500`}>
                <span className="absolute -top-6 -left-2 font-display text-7xl font-black text-transparent bg-gradient-to-br from-pink-300 to-cyan-300 bg-clip-text select-none">
                  {i + 1}
                </span>
                <div className={`inline-flex self-start p-3.5 rounded-2xl bg-gradient-to-br ${s.gradient} shadow-lg mb-5 ml-auto`}>
                  <s.icon className="w-6 h-6 text-white" />
                </div>
                <h3 className="font-display text-2xl font-black text-ink-900">{s.title}</h3>
                <p className="mt-2.5 text-[15px] text-gray-600 leading-relaxed grow">{s.text}</p>
                <Link
                  to={s.cta.to}
                  className="mt-5 inline-flex items-center space-x-1.5 text-sm font-extrabold text-pink-600 hover:translate-x-1 transition-transform"
                >
                  <span>{s.cta.label}</span>
                  <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
